import { render } from "./Zusammenfassung.vue?vue&type=template&id=16ed6fa2"
import script from "./Zusammenfassung.vue?vue&type=script&lang=js"
export * from "./Zusammenfassung.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__